<div class="position-relative d-flex p-3 p-md-5 m-md-3 text-center bg-dark intro-banner">
  <div class="col-md-8 p-lg-5 mx-auto text-white align-self-center">
    <h1 class="display-5 font-weight-bold mx-auto">{{'Secteur logistique' | translate}}</h1>
  </div>
</div>
<contact-us-btn></contact-us-btn>
<hr class="mb-5 mt-3">
<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Analyse du secteur logistique' | translate}}</span>
    </div>
    <div class="container justif-center my-5">
      <p><span class="bold-blue">{{ 'Les services logistiques' | translate}}</span> {{ 'font référence au processus global de gestion de la manière dont les ressources sont acquises, stockées et transportées vers leur destination finale.' | translate}}</p>
    </div>
</div>
<div class="block-free-access py-5">
    <div class="container px-5">
        <div class="block p-0">
            <ul class="nav landing-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="global-tab" data-toggle="tab" href="#global" role="tab" aria-controls="global" aria-selected="true" title="World">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/world_icon.webp" type="image/webp">
                              <source srcset="/assets/world_icon.png" type="image/png">
            									<img src="/assets/world_icon.png" class="pays" alt="Global logistics sector trends: Accidentology and Market Analysis" title="World" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Global' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="usa-tab" data-toggle="tab" href="#usa" role="tab" aria-controls="usa" aria-selected="false" title="USA">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/usa_icon.webp" type="image/webp">
                              <source srcset="/assets/usa_icon.png" type="image/png">
            									<img src="/assets/usa_icon.png" class="pays" alt="United States logistics sector trends: Accidentology and Market Analysis" title="USA" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Etats-Unis' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="france-tab" data-toggle="tab" href="#france" role="tab" aria-controls="france" aria-selected="false" title="France">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/france_icon.webp" type="image/webp">
                              <source srcset="/assets/france_icon.png" type="image/png">
            									<img src="/assets/france_icon.png" class="pays" alt="French logistics sector trends: Accidentology and Market Analysis" title="France" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'France' | translate}}</b>
                    </a>
                </li>
            </ul>
            <hr class="my-0">
            <div class="tab-content text-center py-4 px-3 px-md-5" id="myTabContent">
                <div class="tab-pane fade show active" id="global" role="tabpanel" aria-labelledby="global-tab">
                    <b class="sub-bar">{{'GLOBAL' | translate}}</b>
                    <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                    <ul class="mb-0 mt-2 text-justify">
                      <li>{{'Les cinq accidents les plus courants dans les entrepôts concernent : les quais, les chariots élévateurs à fourche, les convoyeurs, le stockage des matériaux et le levage et la manutention manuels ' | translate}}<a class="source" href="https://www.kokeinc.com/material-handling/warehouse/shocking-safety-warehouse-statistics/" target="_blank" rel="noopener nofollow" title="kokeinc">{{'(source)' | translate}}</a></li>
                      <li>{{'Un travailleur est décédé toutes les 99 minutes des suites d’un accident du travail en 2019 ' | translate}}<a class="source" href="https://www.bls.gov/news.release/pdf/cfoi.pdf" target="_blank" rel="noopener nofollow" title="bls">{{'(source)' | translate}}</a></li>
                    </ul>
                    <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                    <ul class="mb-0 mt-2 text-justify">
                      <li>{{'Le marché mondial de la logistique représentait 9 600 milliards de dollars en 2018 et devrait dépasser les 12 000 milliards de dollars en 2023.' | translate}} <a class="source" href="https://www.freightwaves.com/news/how-big-is-the-logistics-industry" target="_blank" rel="noopener nofollow" title="freightwaves">{{'(source)' | translate}}</a></li>
                    </ul>
                </div>
                <div class="tab-pane fade" id="usa" role="tabpanel" aria-labelledby="usa-tab">
                  <b class="sub-bar">{{'ETATS-UNIS' | translate}}</b>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'Les accidents de chariots élévateurs ont entraîné 85 décès et près de 35 000 blessures graves en 2018 ' | translate}}<a class="source" href="https://thecollectiveintelligencegroup.com/forklift-accident-statistics" target="_blank" rel="noopener nofollow" title="thecollectiveintelligencegroup">{{'(source)' | translate}}</a></li>
                    <li>{{'Les accidents par glissade et chute représentent 15% de tous les décès accidentels dans les entrepôts ' | translate}}<a class="source" href="https://www.kokeinc.com/material-handling/warehouse/shocking-safety-warehouse-statistics/" target="_blank" rel="noopener nofollow" title="kokeinc">{{'(source)' | translate}}</a></li>
                  </ul>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'Les coûts logistiques des entreprises américaines ont atteint 1 600 milliards de dollars en 2018.' | translate}} <a class="source" href="https://www.wsj.com/articles/logistics-spending-jumped-11-4-on-strong-economic-growth-11560862800" target="_blank" rel="noopener nofollow" title="wsj">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
                <div class="tab-pane fade" id="france" role="tabpanel" aria-labelledby="france-tab">
                  <b class="sub-bar">{{'FRANCE' | translate}}</b>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'Les accidents du travail dans le transport et la logistique atteignent 3 500 par an ' | translate}}<a class="source" href="https://www.supplychaininfo.eu/taux-de-frequence/#:~:text=Dans%20le%20transport%20et%20la,repr%C3%A9sente%20%C3%A0%20l'%C3%A9chelle%20nationale." target="_blank" rel="noopener nofollow" title="supplychaininfo">{{'(source)' | translate}}</a></li>
                    <li>{{'Le plus souvent (29%), les accidents du travail surviennent à la suite : d’une blessure en levant, baissant, ou déposant une charge ' | translate}}<a class="source" href="https://www.supplychaininfo.eu/taux-de-frequence/#:~:text=Dans%20le%20transport%20et%20la,repr%C3%A9sente%20%C3%A0%20l'%C3%A9chelle%20nationale." target="_blank" rel="noopener nofollow" title="supplychaininfo">{{'(source)' | translate}}</a></li>
                  </ul>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'Avec le plus grand réseau routier d’Europe, cinq grandes installations portuaires et l’un des meilleurs réseaux ferroviaires d’Europe, la FRANCE est le pays d’Europe qui compte le plus grand nombre de projets industriels et logistiques (générant environ 200 milliards d’euros de revenus annuels).' | translate}} <a class="source" href="https://www.businessfrance.fr/Contents/Item/Display/1328" target="_blank" rel="noopener nofollow" title="businessfrance">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container my-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Challenges du secteur' | translate}}</span>
    </div>
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/1-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Défi n°1 :' | translate}}</p>
                <p class="text-justify">{{'Les innovations numériques ont été introduites à un rythme plus lent dans ce secteur. Maintenant qu’il subit une transformation numérique en continu, il exige de nouveaux modèles commerciaux numériques pour conserver ses positions sur le marché.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Grâce à sa plateforme HSE entièrement virtuelle et basée sur le cloud, Immersive Factory propose des ' | translate}}<a class="source" [routerLink]="language.navigateAccordingToLang(['/blog/146-Immersive-practice-the-assets-of-immersive-learning'])" target="_blank" rel="noopener nofollow" title="Immersive practice the assets of immersive learning">{{'formations immersives' | translate}}</a>{{' aux équipes sur site et/ou à distance, en fournissant des exercices en ligne et des outils pour organiser des formations et des évènements. La sécurité devient ainsi facilement accessible de n’importe où.' | translate}}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/campus-hall-people.webp" type="image/webp">
                <source srcset="assets/campus-hall-people.jpg" type="image/jpg">
                <img src="assets/campus-hall-people.jpg" class="block-rounded abstract-formation" alt="Immersive Factory Virtual Campus" title="Virtual Campus" loading="lazy">
            </picture>
        </div>
    </div>
    <hr class="px-2 mb-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <div class="videoContainer block-rounded abstract-formation mb-2">
                <video poster="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/posters/Accident.jpg" autoplay="autoplay" muted="muted" webkit-playsinline="true" playsinline="true" loop="loop" preload="auto">
                    <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/Accidents.webm" type="video/webm">
                    <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/Accidents.mp4" type="video/mp4">
                </video>
            </div>
        </div>
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/2-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Défi n°2 :' | translate}}</p>
                <p class="text-justify">{{'Le nombre impressionnant d’accidents dans ce secteur est souvent un indicateur clé de performance pour les entreprises de logistique, d’autant plus que leur réduction a un impact bénéfique sur les primes d’assurance. Le défi est cependant de savoir comment minimiser le nombre d’accidents qui se produisent.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Plus de 30 exercices immersifs pouvant être réalisés à plusieurs reprises pour permettre une formation plus rapide et plus efficace afin d’accélérer le développement des compétences. Grâce à l’aspect VR des exercices, les impressions des dangers potentiels sont si réalistes que les conséquences sont gravées dans l’esprit de l’apprenant, ce qui contribuera à réduire le nombre d’accidents du travail.' | translate}}
                </div>
            </div>
        </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/3-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Défi n°3 :' | translate}}</p>
                <p class="text-justify">{{'La communication en matière de gestion logistique pendant la crise du Covid-19 a été difficile. Il s’agit notamment des problèmes liés à la perturbation des chaînes d’approvisionnement, à la difficulté de s’approvisionner en matières premières, au renforcement de la sécurité aux frontières et au manque de transports disponibles.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'La solution à ce défi pourrait être des réunions de sécurité de 15 minutes ayant pour but de transmettre un message essentiel et d’impliquer les associés dans une approche participative. Les collaborateurs ont envie de participer à des activités captivantes et prennent volontiers part à une expérience lorsqu’elle est présentée comme un jeu ! C’est exactement ce que l’apprentissage immersif, tel que le propose Immersive Factory, permet aux organisateurs de faire. Grâce à une plateforme collaborative entièrement numérique, les participants se retrouvent à l’intérieur d’un campus personnalisé où ils peuvent discuter du thème choisi pour la réunion de sécurité de 15 minutes. Ils peuvent également accéder à des modules immersifs en équipe ou participer à des exercices mis à leur disposition sur diverses plateformes médiatiques. VR (avec un casque de type HTC ou Vive FOCUS, par exemple), PC, appareils mobiles (tablette ou smartphone), Mac... Quelle que soit la catégorie d’équipement dont ils disposent, ils pourront profiter des activités.' | translate}}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-4 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/{{'gif-fr-competences-formations' | translate}}.webp" type="image/webp">
                <source srcset="assets/{{'gif-fr-competences-formations' | translate}}.gif" type="image/gif">
                <img src="assets/{{'gif-fr-competences-formations' | translate}}.gif" class="block-rounded" alt="An immersive 3d virtual campus" title="Remote EHS events" loading="lazy">
            </picture>
        </div>
    </div>
</div>
<hr class="my-4">
<div class="container my-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'L’avantage de nous choisir pour suivre votre formation en ligne dans le secteur logistique ?' | translate}}</span>
    </div>
    <div class="text-justify">
    	<p>{{"Immersive Factory met à la disposition des professionnels du secteur logistique, des modules de réalité virtuelle pour les former à la manipulation des engins roulants et aux gestes sûrs pour éviter les accidents sur la route lors du transport de marchandises et de matières premières et sur les chantiers." | translate}}</p>
    	<p>{{"Nous proposons des formations aux entreprises afin qu'elles puissent assurer la sécurité de leurs travailleurs lors de l'utilisation de machines ou du transport de marchandises et personnes par voiture ou par camion, en permettant une sensibilisation régulière aux dangers et une baisse significative des incidents." | translate }}</p>
    	<p>{{"L'utilisation d'un système d'apprentissage en ligne, telle que la plateforme d'apprentissage en ligne VR d'Immersive Learning, est primordiale pour sensibiliser aux risques." | translate }}</p>
    	<p>{{"Nos formations encouragent la prévention dans le secteur logistique en fournissant une formation efficace et accessible qui engage directement votre personnel à de bonnes pratiques et leur donne les pleines connaissances des risques et dangers." | translate }}</p>
    	<p class="mb-0">{{"L'approche de la formation Immersive Factory vous permet de préserver la santé de votre personnel, de respecter les réglementations en vigueur tout en améliorant la formation de votre équipe en termes de réactivité et d'attention aux risques." | translate }}</p>
    </div>
</div>
<hr *ngIf="blocnews" class="my-4">
<div *ngIf="blocnews" class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Envie d’en savoir plus sur les avantages qu’offre l’immersive learning pour le secteur logistique ?' | translate}}</span>
    </div>
    <div class="container my-5">
      <p class="justif-center">{{ 'Venez les découvrir au travers du témoignage de FM Logistic qui a co-développé avec Immersive Factory un module de formation en réalité virtuelle pour sensibiliser leurs équipes aux risques professionnels logistiques :' | translate}}</p>
      <div *ngIf="blocnews" class="mt-4">
        <div class="post row pr-0">
            <div class="col-12 col-md-6 mb-md-0 px-0">
                <a *ngIf="blocnews['link']" [routerLink]="language.navigateAccordingToLang([blocnews['link']])" target="blank" rel="noopener nofollow" title="{{blocnews['title']}}"><img src='{{blocnews.imageHeader}}' class="news-image abstract-formation" alt="FM Logistic testimonial: innovation to enhance health and safety at work" title="FM Logistic testimonial" loading="lazy"></a>
            </div>
            <div class="col-12 col-md-6 px-4 pt-4 mb-4 d-flex justify-content-center align-items-center">
                <div>
                    <p *ngIf="blocnews['title']" class="font-weight-bold ifsolution">{{blocnews["title"]}}</p>
                    <div class="informations my-3">
                        <span *ngIf="blocnews['createdDate']" class="date">{{blocnews["createdDate"]}}</span>
                        <div *ngIf="blocnews.tag['title']" class="tag rounded px-2">{{blocnews.tag["title"]}}</div>
                    </div>
                    <div class="actu-body">
                      <p *ngIf="blocnews['shortDesc']" class="description" [innerHTML]="blocnews['shortDesc']"></p>
                      <a *ngIf="blocnews['link']" [routerLink]="language.navigateAccordingToLang([blocnews['link']])" class="viewmore mb-3" target="blank" rel="noopener nofollow" title="{{blocnews['title']}}">{{'Voir plus' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</div>


<hr class="mt-5">
<div class="reassurance">
    <div class="container py-4 mb-4">
        <h3 class="my-4">{{ 'Ils nous font confiance' | translate}}</h3>
        <owl-carousel
            [options]="{
                items: 5,
                dots: false,
                nav: true,
                margin:0,
                loop:true,
                autoplay:true,
                autoplayTimeout:3000,
                autoplayHoverPause:true,
                responsive:{
                    '300':{
                        items:1,
                        nav:true
                    },
                    '768':{
                        items:3,
                        nav:true
                    },
                    '992':{
                        items:5,
                        nav:true,
                        loop:true
                    }
                }
            }"
            [carouselClasses]="['owl-carousel']">
            <div class="logos-theytrustus" *ngFor="let image of images;let i = index">
                <picture>
                    <source srcset="{{image.url}}.webp" type="image/webp">
                    <source srcset="{{image.url}}.png" type="image/png">
                    <img src="{{image.url}}.png" [attr.alt]="image.alt" [attr.title]="image.title" loading="lazy">
                </picture>
            </div>
        </owl-carousel>
    </div>
</div>
<hr class="my-4">


<div class="container mb-5">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'exercices dédiés au secteur logistique' | translate}}</span>
    </div>
    <div *ngIf="listProducts" class="mt-4">
        <div class="row ml-0 mr-0">
          <app-product-card class="col-md-4 mt-4"  *ngFor="let product of listProducts" [product]="product"></app-product-card>
        </div>
    </div>
</div>
<!-- TEMOIGNAGE CLIENT
<hr class="my-4">
<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Témoignage client' | translate}}</span>
    </div>

    <div class="container-fluid mb-5">
        <div class="row">
            <div class="col-md-6 col-12 latest-pub">
                <h2 class="title-pub bold px-4 pt-2">{{'Téléchargez notre dernier témoignage client' | translate}}</h2>
                <h3 class="text-pub mt-2 px-4">{{'Témoignage EGIS' | translate}}</h3>
                <a href="https://communication.immersivefactory.com/Egis_Testimonial.pdf" target="_blank">
                <div class="download-btn mt-4">
                    <i class="fas fa-download"></i><span class="ml-2">{{'Télécharger' | translate}}</span>
                </div>
                </a>
            </div>
            <div class="col-md-6 col-12 book">
                <div class="magasine magasine-{{language.lang}}">
                </div>
            </div>
        </div>
    </div>
</div>
-->
